import { createReducer, on } from '@ngrx/store';
import { ActiveComponentChanged } from 'src/app/shared/actions/eliqua.actions';
import {
  CloseEditCouponsetSidenav,
  CompanyNameChanged,
  CouponsetsPanelStatusChanged,
  EditCouponset,
  SearchMerchantSuccess,
  StoreFilterChanged,
  StoresPanelStatusChanged,
  WebsiteURLChanged,
} from '../actions/summary.actions';
import { MerchantSummaryState } from '../models/merchant.model';

const initialState: MerchantSummaryState = {
  couponsetsExpansionPanel: false,
  storesExpansionPanel: false,
  companyName: '',
  websiteURL: '',
  memberSince: '',
  officialBrandName: '',
  vatNumber: 0,
  qivosID: '',
  subscriptionPlan: '',
  active: false,
  totalCoupons: '',
  availableCoupons: '',
  givenCoupons: '',
  stores: [],
  storesFilter: '',
  couponsets: [],
  couponSet: null,
  sideNavOpened: false,
};

export const MerchantSummaryReducer = createReducer(
  initialState,
  on(EditCouponset, (state, { couponSet }) => ({
    ...state,
    couponSet,
    sideNavOpened: true,
  })),
  on(CouponsetsPanelStatusChanged, (state) => ({
    ...state,
    couponsetsExpansionPanel: !state.couponsetsExpansionPanel,
    storesExpansionPanel: false,
  })),
  on(StoresPanelStatusChanged, (state) => ({
    ...state,
    storesExpansionPanel: !state.storesExpansionPanel,
    couponsetsExpansionPanel: false,
    storesFilter: '',
  })),
  on(CompanyNameChanged, (state, { companyName }) => ({
    ...state,
    companyName,
  })),
  on(WebsiteURLChanged, (state, { websiteURL }) => ({
    ...state,
    websiteURL,
  })),
  on(SearchMerchantSuccess, (state, { res }) => {
    const subscriptionPlan = res.payload?.data?.attributes.find(
      (attribute: { attributeName: string; attributeValue: string; dataType: string }) =>
        attribute.attributeName === 'SubscriptionPlan',
    );
    return {
      ...state,
      companyName: res.payload?.data?.companyName,
      websiteURL: res.payload?.data?.merchantConfig ? res.payload.data.merchantConfig.website : '',
      officialBrandName: res.payload?.data?.companyName,
      vatNumber: res.payload?.data?.vatNumber,
      qivosID: res.payload?.data?.code,
      memberSince: res.payload?.data?.registrationDate,
      active: res.payload?.data?.active,
      totalCoupons: res.payload?.data?.totalCoupons,
      availableCoupons: res.payload?.data?.availableCoupons,
      givenCoupons: res.payload?.data?.givenCoupons,
      stores: res.payload?.data?.stores,
      couponsets: res.payload?.data?.couponsets,
      subscriptionPlan:
        res.payload?.data?.attributes && res.payload?.data?.attributes.length > 0
          ? subscriptionPlan
            ? subscriptionPlan.attributeValue
            : 'No Subscription Plan'
          : 'No Subscription Plan',
    };
  }),
  on(CloseEditCouponsetSidenav, (state) => ({
    ...state,
    sideNavOpened: false,
  })),
  on(StoreFilterChanged, (state, { storesFilter }) => ({
    ...state,
    storesFilter,
  })),
  on(ActiveComponentChanged, (state, { activeComponent }) => {
    if (activeComponent === 'MerchantSummaryComponent' || activeComponent === 'MerchantDetailsComponent')
      return {
        ...state,
        couponsetsExpansionPanel: false,
        storesExpansionPanel: false,
      };
    return {
      ...state,
      couponsetsExpansionPanel: false,
      storesExpansionPanel: false,
      companyName: '',
      websiteURL: '',
      memberSince: '',
      officialBrandName: '',
      vatNumber: 0,
      qivosID: '',
      subscriptionPlan: '',
      active: false,
      totalCoupons: '',
      availableCoupons: '',
      givenCoupons: '',
      couponSet: null,
      sideNavOpened: false,
    };
  }),
);
